import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { setQuestionProps } from './state/actions';
import QuestionPreviewContainer from './QuestionPreviewContainer';

const QuestionPreviewWrapper = (props) => {
  const {
    userData,
    setQuestionPropsAction,
    isHoverAvailable,
    items,
    hoveredItemParent,
    location,
    params,
    qbCachedLrnQuestionsLimit,
    questionsContainer,
  } = props;

  const { previewId } = params || {};
  const forcePreviewQuery = location?.query?.['force-preview'];

  //Disable this functionality when we are previewing a QB single question
  //or when within the same functionality we move from one page to another
  const isDisabled = Boolean(previewId || forcePreviewQuery);
  const firstItem = items[0];

  if (!firstItem || !isHoverAvailable || isDisabled) {
    return null;
  }

  return (
    <QuestionPreviewContainer
      firstItem={firstItem}
      dynamicItems={items}
      userData={userData}
      setQuestionPropsAction={setQuestionPropsAction}
      hoveredItemParent={hoveredItemParent}
      qbCachedLrnQuestionsLimit={qbCachedLrnQuestionsLimit}
      questionsContainer={questionsContainer}
    />
  );
};

QuestionPreviewWrapper.propTypes = {
  userData: PropTypes.object.isRequired,
  hoveredItemParent: PropTypes.string.isRequired,
  questionsContainer: PropTypes.string.isRequired,
};

const mapStateToProps = ({ featureFlag, userData }) => ({
  isHoverAvailable: featureFlag.hometq_preview_approach_gama,
  qbCachedLrnQuestionsLimit: featureFlag.qb_cached_lrn_questions_limit,
  userData,
});

const mapDispatchToProps = {
  setQuestionPropsAction: setQuestionProps,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(QuestionPreviewWrapper));
